import { render, staticRenderFns } from "./wty-shopinfo.vue?vue&type=template&id=528c03d6&scoped=true&"
import script from "./wty-shopinfo.vue?vue&type=script&lang=js&"
export * from "./wty-shopinfo.vue?vue&type=script&lang=js&"
import style0 from "./wty-shopinfo.vue?vue&type=style&index=0&id=528c03d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c03d6",
  null
  
)

export default component.exports